(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["esek-homepage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const poster = event.target.closest('[data-esek-play-video]');
    if (poster) {
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/UcYwfvQf7NE?rel=0&autoplay=1';
      iframe.title = 'About ESEK';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      poster.replaceWith(iframe);
      iframe.focus();
      return;
    }
    const button = event.target.closest('[data-esek-scroll]');
    if (!button) return;
    const rail = document.getElementById(button.dataset.esekTarget);
    if (!rail) return;
    const direction = button.dataset.esekScroll === 'next' ? 1 : -1;
    rail.scrollBy({ left: direction * rail.clientWidth * 0.82, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
